module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門4_9_2.c41f35d8.png";